import { Theme } from '@fluentui/react-components';
import { createContext } from 'react';

export interface TeamsContextType {
    theme?: Theme;
    themeString: string;
    isInitialized: boolean;
}

export const TeamsContext = createContext<TeamsContextType>({
    theme: undefined,
    themeString: '',
    isInitialized: false,
});
